import { useMediaQuery, useTheme } from '@mui/material';

export function useWidth() {
  const { breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down('sm'));
  const isLargeScreen = useMediaQuery(breakpoints.up('lg'));

  return { isMobile, isLargeScreen };
}
